// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 800px) {
  .sub-menu-opened {
    display: block !important; } }

@media (max-width: 1046px) {
  #heading {
    margin-left: 500px; }
  #heading2 {
    margin-left: 50px !important; }
  .navbar_content {
    margin-right: 0 !important; } }

.navbar {
  position: -webkit-sticky;
  position: sticky !important;
  top: 0;
  background-color: #fff;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.05);
  list-style: none;
  text-transform: uppercase;
  padding: 0;
  height: auto;
  z-index: 9999;
  padding: 0 !important; }

.navbar_content {
  margin-bottom: 0 !important;
  margin-right: 275px;
  float: right !important;
  justify-content: center; }
  .navbar_content li {
    display: inline-block;
    position: relative;
    text-align: -webkit-match-parent-;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 0; }
    .navbar_content li p {
      letter-spacing: 2;
      font-size: 11px;
      line-height: 10px;
      position: relative;
      display: block;
      padding: 10px 1px;
      margin: 7px auto; }

.element_container {
  float: right; }

.element_container > .active li {
  background: #116466;
  color: #fff;
  outline: 0 none; }

.navbar::after {
  clear: both; }

.navbar_content > .active li {
  background: #116466;
  color: #fff;
  outline: 0 none; }

.navbar_content li:hover {
  background: #116466;
  color: #fff;
  outline: 0 none; }

.h6 {
  margin-left: 120px;
  margin-top: 10px; }

* {
  box-sizing: border-box; }

#heading2 {
  margin-left: 50px;
  margin-right: -500px; }

@media (max-width: 1440px) and (min-width: 1046px) {
  #heading {
    margin-right: 750px; } }

@media (min-width: 1440px) and (max-width: 1500px) {
  #heading {
    margin-right: -250px; } }

@media (min-width: 1500px) and (max-width: 1600px) {
  #heading {
    margin-right: -200px; } }

@media (max-width: 768px) {
  #heading {
    margin-right: 60px; } }

@media (max-width: 320px) {
  #heading {
    margin-right: 30px; } }
`, "",{"version":3,"sources":["webpack://./src/store/components/navbar/index.scss"],"names":[],"mappings":"AAAA;EACI;IACI,yBAAyB,EAAA,EAC5B;;AAGL;EACI;IACI,kBACJ,EAAA;EACA;IACI,4BAA4B,EAAA;EAEhC;IACI,0BAAyB,EAAA,EAC5B;;AAKL;EACI,wBAAwB;EACxB,2BAA2B;EAC3B,MAAM;EACN,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qBAAoB,EAAA;;AAIxB;EACI,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB,EAAA;EAJ3B;IAMQ,qBAAqB;IACrB,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc,EAAA;IAXtB;MAaY,iBAAiB;MACjB,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,cAAc;MACd,iBAAiB;MACjB,gBAAgB,EAAA;;AAK5B;EACI,YAAY,EAAA;;AAGhB;EACI,mBAAmB;EACnB,WAAW;EACX,eAAe,EAAA;;AAGnB;EACI,WAAW,EAAA;;AAGf;EACI,mBAAmB;EACnB,WAAW;EACX,eAAe,EAAA;;AAGnB;EACI,mBAAmB;EACnB,WAAW;EACX,eAAe,EAAA;;AAGnB;EACI,kBAAkB;EAClB,gBAAgB,EAAA;;AAGpB;EACI,sBAAsB,EAAA;;AAG1B;EACI,iBAAiB;EACjB,oBAAoB,EAAA;;AAGxB;EACI;IACI,mBAAmB,EAAA,EACtB;;AAGL;EACI;IACI,oBAAoB,EAAA,EACvB;;AAGL;EACI;IACI,oBAAoB,EAAA,EACvB;;AAGL;EACI;IACI,kBAAkB,EAAA,EACrB;;AAGL;EACI;IACI,kBAAkB,EAAA,EACrB","sourcesContent":["@media only screen and (max-width: 800px) {\n    .sub-menu-opened {\n        display: block !important;\n    }\n}\n\n@media (max-width: 1046px) {\n    #heading {\n        margin-left: 500px\n    }\n    #heading2 {\n        margin-left: 50px !important;\n    }\n    .navbar_content {\n        margin-right: 0!important;\n    }\n    \n}\n\n\n.navbar {\n    position: -webkit-sticky;\n    position: sticky !important;\n    top: 0;\n    background-color: #fff;\n    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.05);\n    list-style: none;\n    text-transform: uppercase;\n    padding: 0;\n    height: auto;\n    z-index: 9999;\n    padding: 0!important;\n    // display: inline-block;\n}\n\n.navbar_content {\n    margin-bottom: 0 !important;\n    margin-right: 275px;\n    float: right !important;\n    justify-content: center;\n    li {\n        display: inline-block;\n        position: relative;\n        text-align: -webkit-match-parent-;\n        padding-left: 15px;\n        padding-right: 15px;\n        padding-top: 0;\n        p {\n            letter-spacing: 2;\n            font-size: 11px;\n            line-height: 10px;\n            position: relative;\n            display: block;\n            padding: 10px 1px;\n            margin: 7px auto;\n        }\n    }\n}\n\n.element_container {\n    float: right;\n}\n\n.element_container > .active li {\n    background: #116466;\n    color: #fff;\n    outline: 0 none;\n}\n\n.navbar::after {\n    clear: both;\n}\n\n.navbar_content > .active li {\n    background: #116466;\n    color: #fff;\n    outline: 0 none;\n}\n\n.navbar_content li:hover {\n    background: #116466;\n    color: #fff;\n    outline: 0 none;\n}\n\n.h6 {\n    margin-left: 120px;\n    margin-top: 10px;\n}\n\n* {\n    box-sizing: border-box;\n}\n\n#heading2 {\n    margin-left: 50px;\n    margin-right: -500px;\n}\n\n@media (max-width: 1440px) and (min-width: 1046px){\n    #heading {\n        margin-right: 750px;\n    }\n}\n\n@media (min-width: 1440px) and (max-width: 1500px){\n    #heading {\n        margin-right: -250px;\n    }\n}\n\n@media (min-width: 1500px) and (max-width: 1600px){\n    #heading {\n        margin-right: -200px;\n    }\n}\n\n@media (max-width: 768px){\n    #heading {\n        margin-right: 60px;\n    }\n}\n\n@media (max-width: 320px){\n    #heading {\n        margin-right: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
